/** Confirms deactivating a warehouse. Says "cannot be undone immediately"
 *  rather than "cannot be undone", because reactivating is a support action
 *  rather than an impossibility. */
import { Loader2 } from 'lucide-react';

export default function WarehouseDeactivateModal({
  deleting,
  onCancel,
  onConfirm,
}: {
  deleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-[#1a1f1c] rounded-lg max-w-sm w-full p-6">
        <h3 className="text-lg font-bold text-bark-900 dark:text-stone-100 mb-2">
          Deactivate Warehouse?
        </h3>
        <p className="text-stone-600 dark:text-stone-400 mb-6">
          This warehouse will be marked as inactive. This cannot be undone immediately.
        </p>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            disabled={deleting}
            className="flex-1 px-4 py-2 border rounded-lg hover:bg-stone-50 dark:hover:bg-[#242d28] transition disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={deleting}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {deleting && <Loader2 size={14} className="animate-spin" />}
            Deactivate
          </button>
        </div>
      </div>
    </div>
  );
}
